import React from 'react';
import { Icon, Dicon } from 'edcom-ui';
import styles from './Bottom.module.less';

export default function Bottom() {
  return (
    <div className={styles.container}>
      <div className={styles.socialWrapper}>
        <a
          href="https://www.facebook.com/Education.comFanPage"
          title="Facebook"
          rel="noopener"
          className={styles.social}
        >
          <Icon name="facebook" />
        </a>
        <a
          href="https://twitter.com/education_com"
          title="Twitter"
          rel="noopener"
          className={styles.social}
        >
          <Icon name="twitter" />
        </a>
        <a
          href="https://www.youtube.com/user/brainzyxeducationcom"
          title="YouTube"
          rel="noopener"
          className={styles.social}
        >
          <Icon name="youtube" />
        </a>
        <a
          href="https://www.pinterest.com/education_com/"
          title="Pinterest"
          rel="noopener"
          className={styles.social}
        >
          <Icon name="pinterest" />
        </a>
      </div>
        <div className={styles.ixlLogo}>
          <a href="https://www.ixl.com/" rel="nofollow" aria-label="ixl">
            <Dicon name="ixl-logo" className={styles.ixl} />
          </a>
          <p>Making educational experiences better for everyone.</p>
        </div>
        <div className={styles.ixlProducts}>
          <a className={styles.boxIxlProducts} href="https://www.ixl.com/">
            <h5>IXL</h5>
            <p>Comprehensive K-12 personalized learning</p>
          </a>
          <div className={styles.boxDivider}/>
          <a className={styles.boxIxlProducts} href="https://www.rosettastone.com/">
            <h5>Rosetta Stone</h5>
            <p>Immersive learning for 25 languages</p>
          </a>
          <div className={styles.boxDivider}/>
          <a className={styles.boxIxlProducts} href="https://www.wyzant.com/">
            <h5>Wyzant</h5>
            <p>Trusted tutors for 300 subjects</p>
          </a>
          <div className={styles.boxDivider}/>
          <a className={styles.boxIxlProducts} href="https://www.vocabulary.com/">
            <h5>Vocabulary.com</h5>
            <p>Adaptive learning for English vocabulary</p>
          </a>
          <div className={styles.boxDivider}/>
          <a className={styles.boxIxlProducts} href="https://www.abcya.com/">
            <h5>ABCya</h5>
            <p>Fun educational games for kids</p>
          </a>
          <div className={styles.boxDivider}/>
          <a className={styles.boxIxlProducts} href="https://www.spanishdict.com/">
            <h5>SpanishDict</h5>
            <p>Spanish-English dictionary, translator, and learning</p>
          </a>
          <div className={styles.boxDivider}/>
          <a className={styles.boxIxlProducts} href="https://emmersion.ai/">
            <h5>Emmersion</h5>
            <p>Fast and accurate language certification</p>
          </a>
        </div>
        <div>
          <a href="https://www.kidsafeseal.com/certifiedproducts/education.html" target="_blank" rel="noopener noreferrer">
            <img border="0" alt="Education.com is certified by the kidSAFE Seal Program." src="https://www.kidsafeseal.com/sealimage/50473324616348843/education_small_whitetm.png"/>
          </a>
        </div>
      <div className={styles.copyright}>
    <p className={styles.copyrightText}>Copyright © {new Date().getFullYear()} Education.com, Inc, a division of IXL Learning • All Rights Reserved.</p>
      </div>
    </div>
  );
}
